import { connect } from "react-redux";
import ReturnItem from "./components/ReturnItem";

const GdnReturns = ({ gdn_returns }) => {
  if (!gdn_returns.length) {
    return null;
  }

  return gdn_returns.map((item) => <ReturnItem key={item.id} item={item} />);
};

const mapStateToProps = ({ gdn: { data } }) => ({
  gdn_returns: data?.gdn_returns ?? [],
});

export default connect(mapStateToProps, null)(GdnReturns);
